@if (activePayload()) {
<app-display-renderer [payload]="activePayload()!" [isFallback]="isFallback()" />
} @else {
<div class="display-waiting"></div>
}

@if (debugOverlayEnabled && !hideDebugOverlay) {
<aside class="debug-overlay">
    <div>Connection: {{ connectionState }}</div>
    <div>Site: {{ siteId || 'n/a' }}</div>
    <div>Display: {{ displayId || 'n/a' }}</div>
    <div>Fallback: {{ isFallback() ? 'yes' : 'no' }}</div>
    <div>State: {{ activePayload()?.state ?? 'none' }}</div>
    <div>Last payload: {{ activePayload()?.pushedAt ?? 'none' }}</div>
    <div>Expires: {{ activePayload()?.expiresAt ?? 'none' }}</div>
</aside>
}